const initialState = () => ({
  // First step
  path: undefined,
  application: {},
  flow: '',
  // Overwrite checkbox, step 3
  overwrite: false,

  // Step 2
  // Wordpress + WooCommerce
  wordpress: {
    theme: '',
    plugins: [],
    caching: false,
  },
  wordpress_fields: {
    domain: '',
    siteName: '',
    ssl: false,
    // email: '',
    // password: '',
    // password_confirm: '',
    ssl_exists: false,
    siteDescription: '',
  },
  migration_fields: {
    hostname: '',
    previous_provider: '',
    cp_type: '',
    cp_url: '',
    username: '',
    password: '',
    notes: ''
  },
  sitebuilder: {},
  // starter site
  starterSite: {
    colorPrimary: '',
    colorSecondary: '',
    colorLink: '#1666b2',
    contentHome: '',
    contentAbout: '',
    contentServices: [''],
    physicalAddress: false,
    contactAddress: '',
    contactCity: '',
    contactState: '',
    contactPostcode: '',
    contactCountry: '',
    companyEmail: '',
    companyPhone: '',
    businessHours: 0,
    socialFacebook: '',
    socialTwitter: '',
    socialInstagram: '',
    socialPintrest: '',
    socialLinkedIn: '',
    additional: '',
    hours: {
      hoursOpenSunday: '',
      hoursOpenMonday: '',
      hoursOpenTuesday: '',
      hoursOpenWednesday: '',
      hoursOpenThursday: '',
      hoursOpenFriday: '',
      hoursOpenSaturday: '',
      hoursClosedSunday: '',
      hoursClosedMonday: '',
      hoursClosedTuesday: '',
      hoursClosedWednesday: '',
      hoursClosedThursday: '',
      hoursClosedFriday: '',
      hoursClosedSaturday: '',
    },
    // files
    logoFile: '',
    headerFile: [],
    servicesFile: [],
    aboutFile: [],
    // v2 fields
    websiteTypes: ['Business', 'Organization', 'Event', 'Landing Page', 'Portfolio', 'Other'],
    website_type: 'Other', // sub-step 1
    website_name: '',
    website_description: '',
    other_images: [], // example: [{ id: 123, name: 'my-img.png' }]
  },
  // collective fields:
  theme: '',
})

const state = initialState

const getters = {
  path: state => state.path,
  application: state => state.application,

  wordpress: state => {
    return {
      overwrite: state.overwrite,
      domain: state.wordpress_fields.domain,
      siteName: state.wordpress_fields.siteName,
      ssl: state.wordpress_fields.ssl,
      // email: state.wordpress_fields.email,
      // password: state.wordpress_fields.password,
      // password_confirm: state.wordpress_fields.password_confirm,
      siteDescription: state.wordpress_fields.siteDescription,
      ssl_exists: state.wordpress_fields.ssl_exists,
      theme: state.wordpress.theme,
      plugins: state.wordpress.plugins,
      caching: state.wordpress.caching,
    }
  },
  migration: state => {
    return {
      hostname: state.migration_fields.hostname,
      previous_provider: state.migration_fields.previous_provider,
      cp_type: state.migration_fields.cp_type,
      cp_url: state.migration_fields.cp_url,
      username: state.migration_fields.username,
      password: state.migration_fields.password,
      notes: state.migration_fields.notes,
    }
  },
  ssWebsiteTypes: state => state.starterSite.websiteTypes,
  starterSite: state => {
    let hours = {}
    if (state.starterSite.businessHours) {
      hours = state.starterSite.hours
    }
    const services = state.starterSite.contentServices.reduce((carry, service, index) => {
      carry[`productservice${index + 1}`] = service
      return carry
    }, {})
    return {
      ...state.starterSite,
      theme: state.theme,
      hours: undefined,
      websiteTypes: undefined,
      ...services,
      ...hours,
    }
  },
  theme: state => state.theme,
}

const mutations = {
  // Step 1
  SET_BASIC_CHOICE (state, number) {
    state.path = number
  },
  SET_APPLICATION_CHOICE (state, value) {
    state.application = value
  },
  SET_OVERWRITE (state, value) {
    state.overwrite = value
  },
  // SET_WEBSITE_ALT_CHOICE (state, number) {
  //   state.first_step.config_type_alt = number
  // },
  // Step 2
  SET_INITIAL_MODEL (state, data) {
    switch (data.flow) {
      case 'wordpress':
        state.wordpress = data.defaults
        break
      case 'sitebuilder':
        state.sitebuilder = data.defaults
        break
    }
  },
  SET_WORDPRESS_DOMAIN (state, domain) {
    state.wordpress_fields.domain = domain
  },
  SET_WORDPRESS_SSL_EXISTS (state, exists) {
    state.wordpress_fields.ssl_exists = exists
  },
  SET_WORDPRESS_SITENAME (state, sitename) {
    state.wordpress_fields.siteName = sitename
  },
  SET_WORDPRESS_DESCRIPTION (state, description) {
    state.wordpress_fields.siteDescription = description
  },
  SET_WORDPRESS_SSL (state, ssl) {
    state.wordpress_fields.ssl = ssl
  },
  // SET_WORDPRESS_EMAIL (state, email) {
  //   state.wordpress_fields.email = email
  // },
  // SET_WORDPRESS_PASSWORD (state, password) {
  //   state.wordpress_fields.password = password
  // },
  // SET_WORDPRESS_PASSWORD_CONFIRM (state, password) {
  //   state.wordpress_fields.password_confirm = password
  // },
  SET_WORDPRESS_THEME (state, number) {
    state.wordpress.theme = number
  },
  SET_WORDPRESS_PLUGINS (state, array) {
    state.wordpress.plugins = array
  },
  SET_WORDPRESS_CACHING (state, boolean) {
    state.wordpress.caching = boolean
  },
  SET_MIGRATION_HOSTNAME (state, hostname) {
    state.migration_fields.hostname = hostname
  },
  SET_MIGRATION_PREVIOUS_PROVIDER (state, previous_provider) {
    state.migration_fields.previous_provider = previous_provider
  },
  SET_MIGRATION_CP_TYPE (state, cp_type) {
    state.migration_fields.cp_type = cp_type
  },
  SET_MIGRATION_CP_URL (state, cp_url) {
    state.migration_fields.cp_url = cp_url
  },
  SET_MIGRATION_USERNAME (state, username) {
    state.migration_fields.username = username
  },
  SET_MIGRATION_PASSWORD (state, password) {
    state.migration_fields.password = password
  },
  SET_MIGRATION_NOTES (state, notes) {
    state.migration_fields.notes = notes
  },
  CLEAR_WIZARD_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_SS_CONTENT_HOME (state, content) {
    state.starterSite.contentHome = content
  },
  SET_SS_CONTENT_ABOUT (state, content) {
    state.starterSite.contentAbout = content
  },
  SET_SS_CONTENT_SERVICES (state, services) {
    state.starterSite.contentServices.splice(0, state.starterSite.contentServices.length, ...services)
  },
  SET_SS_PHYSICAL_ADDRESS (state, val) {
    state.starterSite.physicalAddress = val
  },
  SET_SS_ADDRESS (state, address) {
    state.starterSite.contactAddress = address
  },
  SET_SS_CITY (state, city) {
    state.starterSite.contactCity = city
  },
  SET_SS_ZIPCODE (state, zipcode) {
    state.starterSite.contactPostcode = zipcode
  },
  SET_SS_STATE (state, val) {
    state.starterSite.contactState = val
  },
  SET_SS_COUNTRY (state, country) {
    state.starterSite.contactCountry = country
  },
  SET_SS_COMPANY_EMAIL (state, email) {
    state.starterSite.companyEmail = email
  },
  SET_SS_COMPANY_PHONE (state, phone) {
    state.starterSite.companyPhone = phone
  },
  SET_SS_BUSINESS_HOURS (state, hours) {
    state.starterSite.businessHours = hours
  },
  SET_SS_ADDITIONAL (state, additional) {
    state.starterSite.additional = additional
  },
  SET_SS_HOURS (state, { openClosed, day, time }) {
    const ocCapitalized = openClosed.charAt(0).toUpperCase() + openClosed.slice(1)
    const fieldName = 'hours' + ocCapitalized + day
    state.starterSite.hours[fieldName] = time
  },
  SET_SS_FACEBOOK (state, fb) {
    state.starterSite.socialFacebook = fb
  },
  SET_SS_TWITTER (state, val) {
    state.starterSite.socialTwitter = val
  },
  SET_SS_INSTAGRAM (state, val) {
    state.starterSite.socialInstagram = val
  },
  SET_SS_PINTEREST (state, val) {
    state.starterSite.socialPintrest = val
  },
  SET_SS_LINKEDIN (state, val) {
    state.starterSite.socialLinkedIn = val
  },
  SET_SS_LOGO_FILE (state, data) {
    if (data.mode === 'add') {
      state.starterSite.logoFile.push(...data.files)
    } else {
      state.starterSite.logoFile = data
    }
  },
  SET_SS_OTHER_IMGS (state, data) {
    state.starterSite.other_images.splice(0, state.starterSite.other_images.length, ...data)
  },
  SET_SS_HEADER_FILE (state, data) {
    if (data.mode === 'add') {
      state.starterSite.headerFile.push(...data.files)
    } else {
      state.starterSite.headerFile = data
    }
  },
  SET_SS_SERVICES_FILE (state, data) {
    if (data.mode === 'add') {
      state.starterSite.servicesFile.push(...data.files)
    } else {
      state.starterSite.servicesFile = data
    }
  },
  SET_SS_ABOUT_FILE (state, data) {
    if (data.mode === 'add') {
      state.starterSite.aboutFile.push(...data.files)
    } else {
      state.starterSite.aboutFile = data
    }
  },
  SET_SS_TYPE (state, val) {
    if (state.starterSite.websiteTypes.indexOf(val) !== -1) {
      state.starterSite.website_type = val
    }
  },
  SET_SS_WEBSITE_NAME (state, name) {
    state.starterSite.website_name = name
  },
  SET_SS_WEBSITE_DESCRIPTION (state, val) {
    state.starterSite.website_description = val
  },
  SET_THEME (state, theme) {
    state.theme = theme
  },
  SET_PRIMARY_COLOR (state, color) {
    state.starterSite.colorPrimary = color
  },
  SET_SECONDARY_COLOR (state, color) {
    state.starterSite.colorSecondary = color
  },
  SET_LINK_COLOR (state, color) {
    state.starterSite.colorLink = color
  },
}

const actions = {}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
